import { useState } from 'react'
import { getDataCountDisplayPerPage } from '../helpers/common'

const usePaginator = (limitInitial) => {
  const [limit, setLimit] = useState(
    limitInitial === 100
      ? 100
      : getDataCountDisplayPerPage({ limit: limitInitial }),
  )
  const [skip, setSkip] = useState(0)
  const [firstRow, setFirst] = useState(0) // Zero-relative number of the first row to be displayed

  const onPageChange = ({ page, first, rows }) => {
    if (page !== undefined) setSkip(page)
    if (first !== undefined) setFirst(first)
    if (rows !== undefined) setLimit(rows)
  }

  return {
    onPageChange,
    firstRow,
    skip,
    limit,
  }
}

export default usePaginator
